import logo from "./logo.svg";
import "./App.css";
import DashboardTable from "./Components/DashboardTable";
import LinearProgressWithLabel from "./Components/ProgressBar";
import firebase, { db, auth, functions } from "./utils/firebase";
import { useEffect, useState } from "react";
import LoginPage from "./Components/LoginPage";
import { Link, Route, Switch, useLocation, Redirect } from "react-router-dom";
import UserPage from "./pages/user-page/UserPage";
import WeeklyMoversTable from "./Components/WeeklyMoversTable";
import QuizzesPage from "./pages/QuizzesPage/QuizzesPage";
import SurveysPage from "./pages/SurveysPage/SurveysPage";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  CircularProgress,
  Container,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CodingKitsPage from "./pages/CodingKitsPage/CodingKitsPage.js";
import DatabasePage from "./pages/DatabasePage/DatabasePage";
import UserSubscriptions from "./pages/UserSubscriptions/UserSubscriptions";
import ConsumersUsagePage from "./Components/ConsumersUsagePage/ConsumersUsagePage";
import TeamsActivityPage from "./pages/TeamsActivityPage/TeamsActivityPage";
import TeamDetailsPage from "./pages/TeamDetailsPage/TeamDetailsPage";
import ReferralsPage from "./pages/ReferralsPage/ReferralsPage";
import PaywalledPage from "./pages/PaywalledPage/PaywalledPage";
import { getEstimatedServerTimeInMilliseconds } from "./utils/Helpers";
//added
//import { ChakraProvider } from '@chakra-ui/react'

// Reset document body styles completely
document.body.style =
  "background: #d0f2ee; margin: 0; padding: 0; overflow-x: hidden; overflow-y: auto; box-sizing: border-box;";

// Add a reset style tag to ensure all elements have proper box-sizing
const styleEl = document.createElement("style");
styleEl.textContent = `
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
html, body {
  height: 100%;
  overflow-y: auto;
}
`;
document.head.appendChild(styleEl);

function App() {
  const [hasLoadedUser, setHasLoadedUser] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/quizzes", color: "primary" },
    { label: "Database", path: "/database", color: "warning" },
    { label: "Consumers", path: "/consumers", color: "warning" },
    { label: "Consumers Usage", path: "/consumers-usage", color: "warning" },
    { label: "Quiz Surveys", path: "/quizSurveys", color: "warning" },
    { label: "Quizzes", path: "/quizzes", color: "warning" },
    {
      label: "User Subscriptions",
      path: "/userSubscriptions",
      color: "warning",
    },
    { label: "Teams Activity", path: "/teams-activity", color: "warning" },
    { label: "Referrals", path: "/referrals", color: "info" },
    { label: "Paywalled", path: "/paywalled", color: "error" },
    { label: "Coding Kits", path: "/coding-kits", color: "success" },
  ];

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        const userId = user.uid;
        db.collection("users")
          .doc(userId)
          .get()
          .then((doc) => {
            const isAdminLocal = doc.data().isAdmin;
            setIsAdmin(isAdminLocal);
            setHasLoadedUser(true);
          });
      } else {
        // No user is signed in.
        setIsAdmin(false);
        setHasLoadedUser(true);
      }
    });
  }, []);

  useEffect(() => {
    const main = async () => {
      const serverTime = await getEstimatedServerTimeInMilliseconds();
      console.log("serverTime", serverTime);
    };
    main();
  }, []);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer}>
      <List>
        {navItems.map((item) => (
          <ListItem
            button
            component={Link}
            to={item.path}
            key={item.label}
            selected={location.pathname === item.path}
          >
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div
      className="App"
      style={{
        overflowX: "hidden",
        overflowY: "auto",
        width: "100%",
        maxWidth: "100vw",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        minHeight: "100vh",
      }}
    >
      {isAdmin && (
        <>
          <AppBar
            position="static"
            sx={{
              backgroundColor: "#1976d2",
              width: "100%",
              boxShadow: 3,
              left: 0,
              right: 0,
            }}
          >
            <Toolbar>
              {isMobile && (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={toggleDrawer}
                  sx={{ mr: 2 }}
                >
                  <MenuIcon />
                </IconButton>
              )}
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                JuiceMind Dashboard
              </Typography>

              {!isMobile && (
                <Box sx={{ display: "flex" }}>
                  {navItems.map((item) => (
                    <Button
                      key={item.label}
                      component={Link}
                      to={item.path}
                      color={item.color}
                      variant={
                        location.pathname === item.path ? "contained" : "text"
                      }
                      sx={{
                        mx: 0.5,
                        color:
                          location.pathname === item.path ? "white" : "white",
                        backgroundColor:
                          location.pathname === item.path
                            ? item.color === "primary"
                              ? "rgba(25, 118, 210, 0.8)"
                              : "rgba(237, 108, 2, 0.8)"
                            : "transparent",
                        fontSize: "0.85rem",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor:
                            item.color === "primary"
                              ? "rgba(25, 118, 210, 0.9)"
                              : "rgba(237, 108, 2, 0.9)",
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
              )}
            </Toolbar>
          </AppBar>

          <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
            {drawer}
          </Drawer>
        </>
      )}

      <Container
        maxWidth={false}
        disableGutters={true}
        sx={{
          mt: 3,
          mb: 3,
          px: { xs: 2, sm: 2 },
          maxWidth: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          boxSizing: "border-box",
          minHeight: "calc(100vh - 100px)",
        }}
      >
        {!hasLoadedUser ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : isAdmin ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              textAlign: "center",
            }}
          >
            <Switch>
              <Route exact path="/user/:userId">
                <UserPage />
              </Route>
              <Route path="/quizSurveys">
                <SurveysPage />
              </Route>
              <Route path="/quizzes">
                <QuizzesPage />
              </Route>
              <Route path="/userSubscriptions">
                <UserSubscriptions />
              </Route>
              <Route path="/consumers-usage">
                <ConsumersUsagePage />
              </Route>
              <Route path="/database">
                <DatabasePage />
              </Route>
              <Route exact path="/teams-activity">
                <TeamsActivityPage />
              </Route>
              <Route path="/teams-activity/:teamId">
                <TeamDetailsPage />
              </Route>
              <Route path="/referrals">
                <ReferralsPage />
              </Route>
              <Route path="/paywalled">
                <PaywalledPage />
              </Route>
              <Route exact path="/">
                <Redirect to="/quizzes" />
              </Route>
              <Route path="/coding-kits">
                <CodingKitsPage />
              </Route>
            </Switch>
          </Box>
        ) : (
          <LoginPage />
        )}
      </Container>
    </div>
  );
}

export default App;
